import { ReactNode } from 'react'
import { cn } from '@/shared/utils'

interface ContainerProps {
  children: ReactNode
  size?: 'app' | 'content' | 'narrow'
  className?: string
}

export function Container({ children, size = 'app', className }: ContainerProps) {
  const sizeClasses = {
    app: 'container-app',
    content: 'container-content',
    narrow: 'container-narrow'
  }

  return (
    <div className={cn(sizeClasses[size], className)}>
      {children}
    </div>
  )
}
